import { render, staticRenderFns } from "./Relogin.vue?vue&type=template&id=5a8b9876&scoped=true&"
import script from "./Relogin.vue?vue&type=script&lang=ts&"
export * from "./Relogin.vue?vue&type=script&lang=ts&"
import style0 from "./Relogin.vue?vue&type=style&index=0&id=5a8b9876&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8b9876",
  null
  
)

export default component.exports